import { Component, Input, OnInit } from '@angular/core'
import { SafeHtml } from '@angular/platform-browser'
import { BlockDataService } from 'src/app/block-services/block-data.service'
import { BlockFieldsService } from 'src/app/block-services/block-fields.service'
import { BuilderService } from 'src/app/builder-services/builder.service'
import { MixpanelService } from 'src/app/tracking/mixpanel.service'
import { FloatingSocialService, SocialPlatform } from './floating-social.service'

@Component({
  selector: 'block-floating-social',
  templateUrl: './block-floating-social.component.html',
  styleUrls: ['./block-floating-social.component.scss']
})
export class BlockFloatingSocialComponent implements OnInit {
  previewBlock = false
  styleFields = false
  blockData: any

  previewFields = false

  blockId = ''

  @Input() nestedBlock: any = {}
  @Input() importedBlockData: any
  @Input() builderType: 'mobile' | 'website' = 'mobile'

  get socialPlatforms(): SocialPlatform[] {
    return this.floatingSocialService.socialPlatforms
  }

  constructor(
    private blockDataService: BlockDataService,
    public blockFieldsService: BlockFieldsService,
    public builderService: BuilderService,
    private mixPanel: MixpanelService,
    public floatingSocialService: FloatingSocialService
  ) {}

  getPlatformIcon(platform: string): SafeHtml {
    return this.floatingSocialService.getPlatformIcon(platform)
  }

  ngOnInit() {
    if (this.importedBlockData) {
      this.previewBlock = true
      this.previewFields = false
      this.styleFields = false
    }
    if (this.nestedBlock.type == 'floatingSocial') {
      this.blockData = this.nestedBlock
      this.blockId = this.nestedBlock.id
      this.previewBlock = true
    } else {
      this.blockData = this.importedBlockData ? this.importedBlockData : this.blockFieldsService.floatingSocialBlockData
      if (this.importedBlockData && this.importedBlockData.id) {
        this.blockId = this.importedBlockData.id
      } else if (!this.blockId) {
        this.blockId = this.blockDataService.getUniqueId(2)
      }
    }
    this.builderService.showSettingsProgress = false
  }

  /**
   * Appends Block to the Preview, Initial checks if the block is added as initial block addition or appended live
   */
  addBlockToPreview(initial: any = '') {
    let blockData = {
      component: BlockFloatingSocialComponent,
      index: 'latest',
      element: this,
      initial: initial
    }
    this.blockDataService.sendBlockData(blockData)
    this.builderService.blocksCollapsed = true
  }

  appendBlock($event: any) {
    let clonedBlockData = { ...this.blockData }
    this.blockId = this.blockDataService.appendBlocksData(clonedBlockData)
    this.addBlockToPreview()
    this.builderService.showSettingsProgress = false

    this.builderService.logData('Floating Social Block Added', 'Block Add', 'Floating Social Block Added').subscribe(
      () => {},
      () => {}
    )

    this.mixPanel.track('Block Added', {
      projectid: this.builderService.getSelectedProject(),
      block: 'floatingSocial'
    })
  }

  /**
   * Sync the clicked block on click inside the mobile preview
   */
  showData(blockId: any) {
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      blockId = this.blockDataService.getLatestBlockId()
    }
    this.blockFieldsService.clickedBlockId = blockId
    this.blockDataService.sendCurrentBlock(BlockFloatingSocialComponent)
  }

  styleChange(style: any, blockId: any, $event: any, type: string) {
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }
    let blockFields = this.blockDataService.getSelectedBlockData(blockId)

    let data = ''
    if (type == 'select') {
      data = $event.value
    } else if (type == 'text') {
      data = $event.currentTarget.value
    } else if (type == 'slider') {
      data = $event.currentTarget.value + 'px'
    }

    let clonedStyle = { ...blockFields.style }
    clonedStyle[style] = data
    blockFields.style = clonedStyle
  }

  addSocial(blockId: any) {
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }
    let blockFields = this.blockDataService.getSelectedBlockData(blockId)
    let clonedData = { ...blockFields.data }
    let clonedSocials = [...(clonedData.socials || [])]
    clonedSocials.push({ platform: 'whatsapp', url: '' })
    clonedData.socials = clonedSocials
    blockFields.data = clonedData
  }

  removeSocial(blockId: any, index: number) {
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }
    let blockFields = this.blockDataService.getSelectedBlockData(blockId)
    let clonedData = { ...blockFields.data }
    let clonedSocials = [...(clonedData.socials || [])]
    clonedSocials.splice(index, 1)
    clonedData.socials = clonedSocials
    blockFields.data = clonedData
  }

  socialPlatformChange(blockId: any, index: number, $event: any) {
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }
    let blockFields = this.blockDataService.getSelectedBlockData(blockId)
    let clonedData = { ...blockFields.data }
    let clonedSocials = clonedData.socials.map((s: any) => ({ ...s }))
    clonedSocials[index].platform = $event.value
    clonedData.socials = clonedSocials
    blockFields.data = clonedData
  }

  socialUrlChange(blockId: any, index: number, $event: any) {
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }
    let blockFields = this.blockDataService.getSelectedBlockData(blockId)
    let clonedData = { ...blockFields.data }
    let clonedSocials = clonedData.socials.map((s: any) => ({ ...s }))
    clonedSocials[index].url = $event.currentTarget.value
    clonedData.socials = clonedSocials
    blockFields.data = clonedData
  }

  getBlockFields = (id: string) => {
    if (this.importedBlockData) {
      return this.importedBlockData
    }
    return this.blockDataService.getSelectedBlockData(id)
  }

  getPlatformColor(platform: string): string {
    return this.floatingSocialService.getPlatformColor(platform)
  }

  getPlatformLabel(platform: string): string {
    return this.floatingSocialService.getPlatformLabel(platform)
  }

  showStyleTab = () => {
    this.previewBlock = false
    this.previewFields = false
    this.styleFields = true
  }

  showDataTab = () => {
    this.previewBlock = false
    this.previewFields = true
    this.styleFields = false
  }

  checkSidebar = () => {
    if (!this.previewBlock && !this.previewFields && !this.styleFields) {
      return true
    }
    return false
  }

  checkPreview = () => {
    if (this.previewBlock && !this.previewFields && !this.styleFields) {
      return true
    }
    return false
  }

  checkData = () => {
    if (this.previewFields) {
      return true
    }
    return false
  }

  checkStyle = () => {
    if (this.styleFields && !this.previewFields && !this.previewBlock) {
      return true
    }
    return false
  }

  checkSettings = () => {
    if (!this.checkSidebar() && !this.checkPreview()) {
      return true
    }
    return false
  }

  /**
   * Deletes the Block from the mobile Preview
   * Deletes the Block from the JSON Object
   */
  deleteBlock = (blockId: any) => {
    this.blockDataService.removeBlockData(blockId)
  }
}
